/* TROVI · carrusel horizontal de la home (Agente B).
   Vanilla, sin dependencias. Se carga con defer desde tv-product-carousel.liquid.
   El carrusel funciona sin JS (scroll táctil / rueda); el JS añade flechas,
   teclado y un aviso aria-live discreto. */
(function () {
  'use strict';

  if (customElements.get('tv-carousel')) return;

  class TvCarouselElement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-tv-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-tv-prev]');
      this.nextButton = this.querySelector('[data-tv-next]');
      this.status = this.querySelector('[data-tv-status]');
      this.statusTemplate = this.getAttribute('data-status-template') || '';

      this.onScroll = this.throttle(this.update.bind(this), 100);
      this.onKeydown = this.handleKeydown.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKeydown);

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.page(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.page(1));
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.throttle(this.update.bind(this), 150));
        this.resizeObserver.observe(this.track);
      } else {
        this.onResize = this.throttle(this.update.bind(this), 150);
        window.addEventListener('resize', this.onResize);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('keydown', this.onKeydown);
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.statusTimer) clearTimeout(this.statusTimer);
    }

    /* --------------------------------------------------------------- */

    get slides() {
      return Array.prototype.slice.call(this.track.children);
    }

    /** Ancho de un paso = ancho de tarjeta + gap. */
    step() {
      const slides = this.slides;
      if (slides.length < 1) return this.track.clientWidth;
      if (slides.length > 1) {
        const delta = slides[1].offsetLeft - slides[0].offsetLeft;
        if (delta > 0) return delta;
      }
      return slides[0].offsetWidth;
    }

    /** Cuántas tarjetas caben enteras en la ventana visible. */
    perView() {
      const step = this.step();
      if (!step) return 1;
      return Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
    }

    page(direction) {
      const amount = this.step() * this.perView();
      this.track.scrollBy({ left: amount * direction, behavior: this.scrollBehavior() });
      this.announceSoon();
    }

    scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    handleKeydown(event) {
      switch (event.key) {
        case 'ArrowRight':
          event.preventDefault();
          this.page(1);
          break;
        case 'ArrowLeft':
          event.preventDefault();
          this.page(-1);
          break;
        case 'Home':
          event.preventDefault();
          this.track.scrollTo({ left: 0, behavior: this.scrollBehavior() });
          this.announceSoon();
          break;
        case 'End':
          event.preventDefault();
          this.track.scrollTo({ left: this.track.scrollWidth, behavior: this.scrollBehavior() });
          this.announceSoon();
          break;
        default:
          break;
      }
    }

    /* --------------------------------------------------------------- */

    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = Math.round(this.track.scrollLeft);
      const atStart = left <= 1;
      const atEnd = left >= max - 1;

      if (this.prevButton) this.prevButton.toggleAttribute('disabled', atStart);
      if (this.nextButton) this.nextButton.toggleAttribute('disabled', atEnd);

      // Si todo cabe a la vista, las flechas sobran.
      const overflows = max > 1;
      this.toggleAttribute('data-tv-static', !overflows);
      if (this.prevButton) this.prevButton.hidden = !overflows;
      if (this.nextButton) this.nextButton.hidden = !overflows;
    }

    /** aria-live discreto: solo tras una acción del usuario, y agrupado. */
    announceSoon() {
      if (!this.status || !this.statusTemplate) return;
      if (this.statusTimer) clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => this.announce(), 450);
    }

    announce() {
      const total = this.slides.length;
      if (!total) return;
      const step = this.step();
      const first = step ? Math.min(total, Math.round(this.track.scrollLeft / step) + 1) : 1;
      const last = Math.min(total, first + this.perView() - 1);
      this.status.textContent = this.statusTemplate
        .replace('__FIRST__', String(first))
        .replace('__LAST__', String(last))
        .replace('__TOTAL__', String(total));
    }

    throttle(fn, wait) {
      let queued = false;
      let timer = null;
      return function () {
        if (queued) return;
        queued = true;
        timer = setTimeout(() => {
          queued = false;
          fn();
        }, wait);
        void timer;
      };
    }
  }

  customElements.define('tv-carousel', TvCarouselElement);
})();
